import script from "./ContactDataModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactDataModal.vue?vue&type=script&setup=true&lang=ts"

import "./ContactDataModal.vue?vue&type=style&index=0&id=50b1163a&scoped=true&lang=css"

import exportComponent from "../../../../eckpunkt-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50b1163a"]])

export default __exports__